/**
 * Pexels — 상업적 이용 가능, 로컬 영구 호스팅
 * 임금 · 회계 · 고시 사무 업무에 맞는 비즈니스/오피스 이미지
 */
export const images = {
  /** 히어로 — 노트북·차트 분석 (사무/경영) */
  hero: '/images/hero.jpg',
  /** 시범사업·검증 — 오피스 협업 */
  careSupport: '/images/care-support.jpg',
  /** 회계 — 재무 그래프·데스크 */
  desk: '/images/desk.jpg',
  /** 임금 문서 — 서류·계약서 */
  documents: '/images/documents.jpg',
  /** 임금 — 급여·재무 검토 */
  wage: '/images/wage.jpg',
  /** 회계 — 계산기·재무 */
  accounting: '/images/accounting.jpg',
  /** 고시 — 법령·규정 문서 */
  notice: '/images/notice.jpg',
  /** 상담 — 전문가 미팅 */
  consultation: '/images/consultation.jpg',
  /** 법령 — 규정·컴플라이언스 */
  law: '/images/law.jpg',
  /** 협업 — 팀 회의·컨설팅 */
  meeting: '/images/meeting.jpg',
  /** 방문요양 히어로 — 방문 가는 발걸음 */
  visitingHero: '/images/visiting-walk.png',
  /** 첫 화면 게이트 — 방문요양 전신 */
  orgVisitGate: '/images/org-visit-gate.png',
  /** 방문요양 — 문 앞, 노크 */
  visitingCare: '/images/visiting-knock.png',
  /** 방문요양 — 환대, 열린 문 */
  visitingTeam: '/images/visiting-welcome.png',
  /** 홈 기관유형 — 요양원·주간보호 시설 */
  orgFacility: '/images/org-facility.jpg',
} as const

export const imageCredits = 'Photo: Pexels (상업적 이용 가능)'
